import axios from "axios";

const api = axios.create({
  baseURL: "https://rest-countries-api-with-json-server.vercel.app",
});

export default api;
